import React from "react";
import { parseTemplate } from "@gqlapp/theme/parser";
import { renderNode } from "@gqlapp/theme/renderer";

export default function Theme(
    { template, context }: any) {
    const ast = parseTemplate(template, context);
    return <>{ast.map((node: any, idx: number) =>
        renderNode(node, idx, context))
    }</>;
}
